import { z, ZodSchema } from "zod";
import { MeasuringSystem } from "../../types";

export interface SpermFile {
  label?: string;
  signedUrl?: string;
  path?: string;
}

export interface FormData {
  patient: string;
  birth: Date | string | null;
  ethnicity: number[];
  height: number;
  weight: number;
  history: string;
  sample: string;
  tech: string;
  files?: number;
}

export interface FormResponse {
  cycle: { id: string; created: string };
}

export interface GetCycleResponseImage {
  id: number;
}

export interface GetCycleResponseItem {
  id: string;
  patient: string;
  birth: string;
  created: string;
}

export interface GetCycleResponse {
  next_page_token: string | null;
  cycle: GetCycleResponseItem;
}

export const createSchema = (system: MeasuringSystem): ZodSchema<FormData> => {
  return z.object({
    patient: z
      .string({ message: "errors.patient.required" })
      .min(2, { message: "errors.patient.required" })
      .max(32, { message: "errors.patient.required" }),
    birth: z.date({ message: "errors.birth.invalid" }),
    height: z
      .number({ message: "errors.height.invalid" })
      .int()
      .min(120, { message: "errors.height.range" })
      .max(240, { message: "errors.height.range" }),
    weight: z
      .number({ message: "errors.weight.invalid" })
      .int()
      .min(40, { message: "errors.weight.range" })
      .max(160, { message: "errors.weight.range" }),
    ethnicity: z.array(z.any(), { message: "errors.ethnicity.required" }),
    history: z.string().max(512, { message: "errors.history.length" }),
    sample: z.string(),
    tech: z.string(),
  
  });
};

export const scoretoColor = (score: number) => {
  if (score <= 20) return "#FEF08A";
  if (score <= 35) return "#FDBA74";
  if (score <= 60) return "#C4B5FD";
  return "#C1DCA0";
};
